import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=53a121dd&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&lang=js&"
export * from "./MainLayout.vue?vue&type=script&lang=js&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=53a121dd&scoped=true&lang=css&"
import style2 from "./MainLayout.vue?vue&type=style&index=2&id=53a121dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a121dd",
  null
  
)

export default component.exports